import { i as t } from "../internals/is-callable.js";
import { i as r } from "../internals/is-object.js";
import "../internals/object-define-property.js";
import { o } from "../internals/object-get-prototype-of.js";
import { w as i } from "../internals/well-known-symbol.js";
import { m as e } from "../internals/make-built-in.js";
import { __exports as n } from "../../../_virtual/object-define-property.js";
var s = i("hasInstance"),
  a = Function.prototype;
s in a || n.f(a, s, {
  value: e(function (i) {
    if (!t(this) || !r(i)) return !1;
    var e = this.prototype;
    if (!r(e)) return i instanceof this;
    for (; i = o(i);) if (e === i) return !0;
    return !1;
  }, s)
});